export const GET_TRAINED_DATA = 'GET_TRAINED_DATA'
export const DELETE_TRAINED_DATA = 'DELETE_TRAINED_DATA'
export const GET_WALKTHROUGHS_DATA = 'GET_WALKTHROUGHS_DATA'
export const GET_CHAT_HISTORY_DATA = 'GET_CHAT_HISTORY_DATA'
export const UPDATE_COLLECTION_DOCS_LIST = 'UPDATE_COLLECTION_DOCS_LIST'
